import React, { ReactElement } from 'react'
import styles from './SplashPageTitle.module.scss'
import { SplashPageProps } from '@/components/sharedFetchStaticProps/fetchSplashPageProps'
import { getCourseConfig } from 'common/src/courseConfig'
import { getSplashPageExamsLabel } from '@/utils/courseOfferings'

export const SplashPageTitle: React.FC<SplashPageProps> = (
    props
): ReactElement => {
    const courseConfig = getCourseConfig(props.courseConfigType)
    return (
        <div className={styles.text}>
            {/* h1/h2 rather than span/div so the homepage has a real heading
                structure for search engines. Both are styled display: inline /
                block with no default margins, so this renders identically. */}
            <h1 className={styles.titleText}>
                <span className={styles.emphasis}>{courseConfig.name}</span> to
                pass your exam.
            </h1>
            <h2 className={styles.subtitleText}>
                Ace your {getSplashPageExamsLabel(props.coursesInfo)} exams
                using our digital analytics-driven platform
            </h2>
        </div>
    )
}
